const STORAGE_KEY = 'buyme_verified_only';

export type VerifiedOnlyValue = '0' | '1';

export function readVerifiedOnlySession(): VerifiedOnlyValue | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw === '0' || raw === '1') return raw;
  } catch {
    /* private mode / blocked storage */
  }
  return null;
}

export function writeVerifiedOnlySession(value: VerifiedOnlyValue): void {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.setItem(STORAGE_KEY, value);
  } catch {
    /* ignore */
  }
}

/** URL param wins when present; otherwise session; otherwise default off (`0`). */
export function resolveVerifiedOnly(urlParam?: string | null): VerifiedOnlyValue {
  if (urlParam === '0' || urlParam === '1') return urlParam;
  return readVerifiedOnlySession() ?? '0';
}
